var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/promo-rotational-banner.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/promo-rotational-banner.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("contentfulUrl")) {
var t_4 = t_1.contentfulUrl;
} else {
cb(new Error("cannot import 'contentfulUrl'")); return;
}
context.setVariable("contentfulUrl", t_4);
output += "\n\n";
var t_5;
t_5 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"secondaryFooterPromo");
frame.set("promo", t_5, true);
if(frame.topLevel) {
context.setVariable("promo", t_5);
}
if(frame.topLevel) {
context.addExport("promo", t_5);
}
output += "\n";
var t_6;
t_6 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"imagePresets")),"default_image_quality");
frame.set("imageQuality", t_6, true);
if(frame.topLevel) {
context.setVariable("imageQuality", t_6);
}
if(frame.topLevel) {
context.addExport("imageQuality", t_6);
}
output += "\n";
var t_7;
t_7 = (lineno = 4, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["promo.linkAltText",""]));
frame.set("linkAltTextSafe", t_7, true);
if(frame.topLevel) {
context.setVariable("linkAltTextSafe", t_7);
}
if(frame.topLevel) {
context.addExport("linkAltTextSafe", t_7);
}
output += "\n\n<div class=\"c-footer-promo__simple-banner dom-secondary-footer-promo\" data-qa-secondary-footer-promo>\n\n    <a ";
output += runtime.suppressValue((lineno = 8, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["marketing","footer_long",runtime.contextOrFrameLookup(context, frame, "linkAltTextSafe")])), env.opts.autoescape);
output += " href=\"";
output += runtime.suppressValue((lineno = 8, colno = 77, runtime.callWrap(t_4, "contentfulUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"url")])), env.opts.autoescape);
output += "\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"externalLink")) {
output += " target=\"_blank\" rel=\"noopener noreferrer\" ";
;
}
output += ">\n\n        <picture>\n\n            <source media=\"medium\" data-srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"alternateBannerImage"), env.opts.autoescape);
output += "\" />\n\n            <img\n                 class=\"c-footer-promo__image lazyload\"\n                 alt=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "linkAltTextSafe"), env.opts.autoescape);
output += "\"\n                 src=\"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==\"\n                 data-srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"bannerImage"), env.opts.autoescape);
if(runtime.contextOrFrameLookup(context, frame, "imageQuality")) {
output += "?q=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "imageQuality"), env.opts.autoescape);
;
}
output += "\" />\n\n        </picture>\n\n    </a>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/promo-rotational-banner.j2"] , dependencies)